module.exports = __webpack_public_path__ + "img/YAHAM.68664da4.png";